import React from "react";
import {useTranslation} from "react-i18next";
import styled from "styled-components";

// „Очаквайте <следващия месец>“ + общата визия за месеца (02.11.2026).
// Показва се, когато за следващия месец има визия в program.json (качваме я около 15-о число),
// и изчезва, щом се качат отделните вечери за следващия месец (около 20-о).
// На компютър – широката визия (web), на телефон – вертикалната (social). Клик отваря визията в голям размер.

const Wrapper = styled.div`
    width: 90%;
    max-width: 900px;
    margin: 70px auto 10px;
    text-align: center;

    h3 {
        font-family: "Montserrat", sans-serif;
        font-size: 1.6em;
        font-weight: 700;
        letter-spacing: 1px;
        color: #fff;
        margin: 0 0 20px;
    }

    img {
        display: block;
        width: 100%;
        height: auto;
        border-radius: 6px;
    }

    @media (max-width: 800px) {
        width: 92%;
        margin: 50px auto 10px;
        h3 { font-size: 1.2em; }
    }
`;

const NextMonthTeaser = ({monthKey, visual}) => {
    const {t} = useTranslation();
    if (!visual) return null;
    const monthName = new Date(monthKey + "-15T12:00:00Z").toLocaleDateString("en", {month: "long", timeZone: "UTC"});
    const phone = typeof window !== "undefined" && window.matchMedia && window.matchMedia("(max-width: 800px)").matches;
    return (
        <Wrapper>
            <h3>{t("COMING IN")} {t(monthName).toUpperCase()}</h3>
            <a href={phone ? visual.social : visual.web} target="_blank" rel="noopener noreferrer">
                <picture>
                    <source media="(max-width: 800px)" srcSet={visual.social}/>
                    <img src={visual.web} alt={visual.alt} loading="lazy"/>
                </picture>
            </a>
        </Wrapper>
    );
};

export default NextMonthTeaser;
